module.exports = __webpack_public_path__ + "images/icon_add.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/icon_add.svg
// module id = 17
// module chunks = 0